import app from "../main";

const notifyHelper = {
    error(message, options = {}) {
        this.show(message, "error", options);
    },
    success(message, options = {}) {
        this.show(message, "success", options);
    },
    warning(message, options = {}) {
        this.show(message, "warn", options);
    },
    info(message, options = {}) {
        this.show(message, "info", options);
    },
    show(message, type, options = {}) {
        let dOptions = {
            group: "app-notify",
            type: type,
            title: app.$t("Notify title"),
            duration: 3000,
            text: app.$t(message)
        };

        Object.keys(dOptions).forEach(key => {
            if (typeof options[key] === "undefined" || options[key] == null)
                options[key] = dOptions[key];
        })

        app.$notify(options);
    }
}

export default notifyHelper;
